import {
  capitalize,
  Checkbox,
  FormControlLabel,
  Paper,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React, { FC } from "react";

interface TemplateOverrideProps {
  warningString?: string;
  checkboxString?: string;
  onChange: () => void;
  checked: boolean;
  disabled?: boolean;
}
export const TemplateOverride: FC<TemplateOverrideProps> = ({
  warningString,
  checkboxString,
  onChange,
  checked,
  disabled,
}) => {
  const { t } = useTranslation();
  const defaultWarning = capitalize(
    t("views.autotractor.equipment.customInfoBlurb")
  );
  const defaultCheckbox = t("views.autotractor.equipment.overrideTemplate");
  return (
    <Paper className="flex flex-col gap-2 p-4">
      <div className="flex gap-1">
        <InfoOutlinedIcon />
        <Typography>{warningString ?? defaultWarning}</Typography>
      </div>
      <FormControlLabel
        label={checkboxString ?? defaultCheckbox}
        checked={checked}
        control={<Checkbox disabled={disabled} />}
        onChange={onChange}
      />
    </Paper>
  );
};
